const BC = {
    Methods: {},
    loadFunction (methodName, context) {
        try {
            const method = methodName.split('(');
            let payload;
            if (method.length > 1) {
                const rawPayload = method[1].slice(0, method[1].length - 1);
                if (rawPayload.length > 0) {
                    payload = JSON.parse(rawPayload);
                }
            }
            BC.Methods[method[0]](context, payload);
        } catch (e) {
            console.error(methodName, e);
        }
    },
    loadFunctions () {
        const elems = document.querySelectorAll('*[data-function]');
        elems.forEach(el => {
            const methods = el.getAttribute('data-function').split('|');
            methods.forEach(method => this.loadFunction(method.trim(), el));
        });
    }
};
export default BC;
